import AppConfig from "../config/app";

export const goToUserMcShowit = (userId) => {
  window.open(`${AppConfig.adminURL}/users/view/${userId}`, "_blank");
};
